export default function hasBackgroundElement(styling, whichStyle, windowWidth, elementType, asdada) {

  if (!styling) return;


  let thisSource;
  let shouldHide;
  let isUploadViewport;

  if (styling[whichStyle] && styling[whichStyle]['0'] && styling[whichStyle]['0'][elementType]) {
    if (styling[whichStyle]['0'][elementType]){
      thisSource = styling[whichStyle]['0'][elementType];
      if (windowWidth === '0') isUploadViewport = true;
    }
    if (styling[whichStyle]['0'][`background${(elementType === 'video' || elementType === 'videoFallback') ? 'Video' : 'Image'}State`] && styling[whichStyle]['0'][`background${(elementType === 'video' || elementType === 'videoFallback') ? 'Video' : 'Image'}State`] === 'hide') shouldHide = true;
  }
  if ((windowWidth === '76_8' || windowWidth === '37_5') && styling[whichStyle] && styling[whichStyle]['76_8']) {
    if (styling[whichStyle]['76_8'][elementType]) {
      thisSource = styling[whichStyle]['76_8'][elementType];
      if (windowWidth === '76_8') isUploadViewport = true;
    }
    if (styling[whichStyle]['76_8'][`background${(elementType === 'video' || elementType === 'videoFallback') ? 'Video' : 'Image'}State`] && styling[whichStyle]['76_8'][`background${(elementType === 'video' || elementType === 'videoFallback') ? 'Video' : 'Image'}State`] === 'hide') {
      shouldHide = true;
    } else {

      if (styling[whichStyle]['76_8'] && styling[whichStyle]['76_8'][`background${(elementType === 'video' || elementType === 'videoFallback') ? 'Video' : 'Image'}State`] && styling[whichStyle]['76_8'][`background${(elementType === 'video' || elementType === 'videoFallback') ? 'Video' : 'Image'}State`] === 'show') {
        if (styling[whichStyle]['0'] && styling[whichStyle]['0'][elementType]) {
          thisSource = styling[whichStyle]['0'][elementType];
          shouldHide = false; 
        }           
      }
  
    }
  }

  if (windowWidth === '37_5' && styling[whichStyle]) {
    
    if (styling[whichStyle]['37_5'] && styling[whichStyle]['37_5'][elementType]) {
      thisSource = styling[whichStyle]['37_5'][elementType];
      if (windowWidth === '37_5') isUploadViewport = true;
    }
    if (styling[whichStyle]['37_5'] && styling[whichStyle]['37_5'][`background${(elementType === 'video' || elementType === 'videoFallback') ? 'Video' : 'Image'}State`] && styling[whichStyle]['37_5'][`background${(elementType === 'video' || elementType === 'videoFallback') ? 'Video' : 'Image'}State`] === 'hide') {
      shouldHide = true;
    } else {

      if (styling[whichStyle]['37_5'] && styling[whichStyle]['37_5'][`background${(elementType === 'video' || elementType === 'videoFallback') ? 'Video' : 'Image'}State`] && styling[whichStyle]['37_5'][`background${(elementType === 'video' || elementType === 'videoFallback') ? 'Video' : 'Image'}State`] === 'show') {
        if (styling[whichStyle]['0'] && styling[whichStyle]['0'][elementType]) {
          thisSource = styling[whichStyle]['0'][elementType];
          shouldHide = false; 
        }
        if (styling[whichStyle]['76_8'] && styling[whichStyle]['76_8'][elementType]) {
          thisSource = styling[whichStyle]['76_8'][elementType]; 
          shouldHide = false;    
        }           
      }
  
    }

  }

  return {
    isHidden: shouldHide,
    [(elementType === 'video' || elementType === 'videoFallback') ? 'video' : 'image']: thisSource,
    isUploadViewport: isUploadViewport
  };
}